import { Field, Form, Formik } from 'formik';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import * as Yup from 'yup';
import PrimaryButton from '../../components/Buttons/PrimaryButton/PrimaryButton';
import TextField from '../../components/TextField/TextField';
import { setFormData } from '../../app/slices/formSlice';
import Page from '../../components/Page/Page';
import style from './HomePage.module.scss';
import ReactGoogleAutocomplete from 'react-google-autocomplete';
import { First } from './Steps/first/first';
import { Second } from './Steps/second/second';

export default function HomePage() {
  const [step, setStep] = useState(1);
  const initialValues = {
    userName: '',
    salonName: '',
    salonAddress:{}
  };
  const validationSchema = Yup.object().shape({
    userName: Yup.string().required('Campo obbligatorio'),
    phoneNumber: Yup.string().required('Campo obbligatorio'),
    salonName: Yup.string().required('Campo obbligatorio'),
    email: Yup.string().email('Email non valida').required('Campo obbligatorio'),
    password: Yup.string().required('Campo obbligatorio'),
    passwordConfirmation: Yup.string().oneOf([Yup.ref('password'), null], 'Le password non coincidono').required('Campo obbligatorio'),
    salonAddress: Yup.object().shape({
      postalCode: Yup.string(),
      streetNumber: Yup.string(),
      city: Yup.string().required('perfavore sia più specifico con la città'),
      province: Yup.string().required('perfavore sia più specifico con la provincia'),
      street: Yup.string().required('perfavore sia più specifico con la via'),
      lng: Yup.string(),
      lat: Yup.string(),
      address: Yup.string(),
    }),
  });

  const options = [
    {
      value: 'proprietario',
      label: 'Proprietario',
    },
    {
      value: 'dipendente',
      label: 'Dipendente',
    },
  ];

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleNextStep = (values) => {
    dispatch(setFormData(values));
    navigate('/account');
  };
  const Steps = (form) => {
    switch (step) {
      case 1:
        return <First form={form} next={() => { setStep(2); }} />;
      case 2:
        return <Second form={form} 
        next={() => { setStep(1); }} 
        back={() => { setStep(1); }}
        />;
      default:
         return <First form={form} next={() => { setStep(2); }} />;
    }
  }
  return (
    <Page>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        
        validateOnBlur
        validateOnChange
        onSubmit={
          async (values) => {
            handleNextStep(values);
          }
        }
      >
        {(form) => (
          <Form className={clsx(style.form)}>
              <Steps form={form}/>
          </Form>
        )}
      </Formik>

    </Page>
  );
}
